import * as React from "react";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";

const useKeyPress = (targetKey, callback, options = { repeat: false }) => {
  React.useEffect(() => {
    let interval = null;

    const downHandler = (event) => {
      if (event.key === targetKey) {
        event.preventDefault();
        event.stopPropagation();

        if (options.repeat) {
          if (!interval) {
            callback();
            interval = setInterval(callback, 150);
          }
        } else {
          callback();
        }
      }
    };

    const upHandler = (event) => {
      if (event.key === targetKey && interval) {
        clearInterval(interval);
        interval = null;
      }
    };

    window.addEventListener("keydown", downHandler, true);
    window.addEventListener("keyup", upHandler, true);

    return () => {
      window.removeEventListener("keydown", downHandler, true);
      window.removeEventListener("keyup", upHandler, true);
      clearInterval(interval);
    };
  }, [targetKey, callback, options]);
};

export default function GenericDrugList(props) {
  const [rowIndex, setRowIndex] = React.useState(0);
  const [selected, setSelected] = React.useState([]);
  const [selectedObj, setSelectedObj] = React.useState(null);
  const rowRefs = React.useRef([]);

  const { dataResult } = props;

  const removeHeaders = (headers, fieldToRemove) =>
    headers.filter((v) => !fieldToRemove.includes(v));

  const allHeaders = Object.keys(dataResult?.length ? dataResult[0] : []);
  const headers = removeHeaders(allHeaders, [
    "Id",
    "id",
    "value",
    "IsTemplate",
    "IsCultureTest",
    "LabWorkOrderTestId",
  ]);

  React.useEffect(() => {
    if (dataResult.length > 0) {
      setSelectedObj(dataResult[0]);
      props.setSelectedGenericDrug?.(dataResult[0]);
    }
  }, [dataResult]);

  const handleArrowUp = () => {
    setRowIndex((prev) => {
      const newIndex = prev === 0 ? dataResult.length - 1 : prev - 1;
      const newSelected = dataResult[newIndex];
      setSelectedObj(newSelected);
      props.setSelectedGenericDrug?.(newSelected);
      return newIndex;
    });
  };

  const handleArrowDown = () => {
    setRowIndex((prev) => {
      const newIndex = prev === dataResult.length - 1 ? 0 : prev + 1;
      const newSelected = dataResult[newIndex];
      setSelectedObj(newSelected);
      props.setSelectedGenericDrug?.(newSelected);
      return newIndex;
    });
  };

  useKeyPress("ArrowUp", handleArrowUp);
  useKeyPress("ArrowDown", handleArrowDown);

  useKeyPress(
    "Enter",
    () => {
      if (selectedObj) {
        props.setSelectedGenericDrug(selectedObj);
        props.close();
      }
    },
    { repeat: false }
  );

  React.useEffect(() => {
    if (rowRefs.current[rowIndex]) {
      rowRefs.current[rowIndex].scrollIntoView({
        behavior: "smooth",
        block: "nearest",
      });
    }
  }, [rowIndex]);

  return (
    <div className="w-auto grid">
      <Box sx={{ width: "100%" }}>
        <Paper sx={{ width: "100%" }}>
          <TableContainer
            sx={{
              "&::-webkit-scrollbar": { width: 7, height: 10 },
              "&::-webkit-scrollbar-track": { backgroundColor: "#7393B3" },
              "&::-webkit-scrollbar-thumb": { backgroundColor: "lightBlue" },
            }}
            className="rounded  max-h-[65vh] overflow-y-auto"
          >
            <Table size="small" component={Paper}>
              <TableHead>
                <TableRow sx={{ "& th": { backgroundColor: "#F1F1F1" } }}>
                  {headers.map((header, index) => (
                    <TableCell
                      sx={{
                        position: "sticky",
                        top: 0,
                        backgroundColor: "#F1F1F1",
                        zIndex: 1,
                      }}
                      key={index}
                      className="whitespace-nowrap sticky"
                    >
                      <span className="text-gray-600 font-bold">
                        {header === "label" ? "Sub Functionality" : header}
                      </span>
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {dataResult.length > 0
                  ? dataResult.map((row, index) => {
                      const isItemSelected = selected.includes(row.Id);
                      return (
                        <TableRow
                          hover
                          ref={(el) => (rowRefs.current[index] = el)}
                          onClick={() => {
                            setSelectedObj(row);
                            props.setSelectedGenericDrug?.(row);
                            setSelected((prev) =>
                              prev.includes(row.Id) ? [] : [row.Id]
                            );

                            setRowIndex(index);
                          }}
                          key={row.Id}
                          selected={isItemSelected}
                          style={{
                            backgroundColor:
                              rowIndex === index ? "#FFC44B" : "",
                          }}
                        >
                          {headers.map((header) => (
                            <TableCell
                              key={header}
                              className="whitespace-nowrap"
                            >
                              {row[header]}
                            </TableCell>
                          ))}
                        </TableRow>
                      );
                    })
                  : ""}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
      </Box>
    </div>
  );
}
